import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Insurer.Delete.IRequest;
type Response = Api.Core.Insurer.Delete.IResponse;
type Headers = Api.Core.Insurer.Delete.IHeaders;
const url = '/api/ProductManagement/Insurer/:id';
export default async function insurerDeleteApi(id: number): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.delete,
    url: createPathFromRoute(url, { id }),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
